module.exports = __webpack_public_path__ + "static/img/6702_phase_function_Paper_PointsHejduk_Prediction.24bd230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6702_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SoE7
// module chunks = 0